//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    setPluginIcon
} from "@/assets/js/appFunc";
import { dropdownToggles } from "./consts";
import AQDropdown from "../../../../../components/Generics/AQDropdown/AQDropdown.vue";

const approvalMatrixImg = require("@/assets/images/ActivitiesIcons/Approval Matrix.svg");

export default {
    components: {
        AQDropdown
    },
    props: {
        propName: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            testComputed2: [
                {
                    value: "2",
                    label: "test2131231LONGTestAndsomeMore text",
                    badgeProps: {
                        badgeText: "qwe"
                    },
                    rightIcon: { name: "add", size: "12px", color: "red" },
                    // avatarProps: { type: "userPlatform" },
                    itemDisabled: false,
                    tooltipProps: {
                        tooltipContent: "test2131231LONGTestAndsomeMore text"
                    }
                },
                {
                    value: "3",
                    label: "test2",
                    rightIcon: { name: "add", size: "18px", color: "blue" }
                    // avatarProps: { type: "applicationSpecific" }
                }
            ],
            statusesData:
            [
                {
                    label: this.$t("tasks.filterBy.overdue"),
                    value: "OVERDUE",
                    leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#D90000" }
                },
                {
                    label: this.$t("tasks.filterBy.inWarning"),
                    value: "AT_RISK",
                    leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#FB8C00" }
                },
                {
                    label: this.$t("tasks.filterBy.attention"),
                    value: "ATTENTION",
                    leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#FFD600" }
                },
                {
                    label: this.$t("tasks.filterBy.onTime"),
                    value: "ON_TRACK",
                    leftIcon: { name: "mdi-checkbox-blank-circle", size: "16px", color: "#14B100" }
                }
            ],
            filterObject: {
                statusesMod: []
            },
            toggleArray: [],
            toggles: dropdownToggles,
            testModel: null,
            defaultValue: "12",
            defaultMultipleValues: ["6", "7", "1", "2", "3"],
            errorDefaultPath: true,
            simpleList: [
                {
                    svgIcon: this.setActivity(),
                    label: "full props and a logn name for this one to check"

                },
                {
                    label: "full props and a logn name for this one to check"

                },
                {
                    label: "full props and a logn name for this one to check"

                },
                {
                    label: "full props and a logn name for this one to check"

                }
            ],
            list2: [
                {
                    svgIcon: { name: approvalMatrixImg, size: "16px" },
                    value: "1",
                    label: "full props and a logn name for this one to check",
                    badgeProps: {
                        badgeText: "qwe"
                    },
                    leftIcon: { name: "add", size: "12px", color: "red" },
                    // avatarProps: { type: "platformManager" },
                    tooltipProps: {
                        tooltipContent: "test2131231L"
                    },
                    chipProps: { type: "user", content: "someUser" }
                },
                {
                    value: "2",
                    label: "test2131231LONGTestAndsomeMore text",
                    badgeProps: {
                        badgeText: "qwe"
                    },
                    rightIcon: { name: "add", size: "12px", color: "red" },
                    // avatarProps: { type: "userPlatform" },
                    itemDisabled: false,
                    tooltipProps: {
                        tooltipContent: "test2131231LONGTestAndsomeMore text"
                    }
                },
                {
                    value: "3",
                    label: "test2",
                    rightIcon: { name: "add", size: "18px", color: "blue" }
                    // avatarProps: { type: "applicationSpecific" }
                },
                {
                    value: "4",
                    label: "test3",
                    rightIcon: { name: "edit" }
                    // avatarProps: { type: "externalGroup" }
                },
                {
                    value: "5",
                    label: "test4",
                    rightIcon: { name: "mdi-account-circle" },
                    // avatarProps: { type: "userPlatform" },
                    chipProps: { content: "qwerty" },
                    description: "other description"
                },
                {
                    value: "6",
                    label: "qwerty1",
                    // avatarProps: { type: "userPlatform" },
                    chipProps: {
                        content: "qwerty",
                        innerContent: "Class",
                        type: "m_datamodel"
                    },
                    description: "one description"
                },
                {
                    value: "7",
                    label: "qwerty22",
                    // avatarProps: { type: "externallySetManager" },
                    description:
                        "one description to see how it works , and its a veryl long one too see this too",
                    chipProps: { content: "qwerty" },
                    rightIcon: { name: "mdi-account-circle" }
                }
            ]
        };
    },
    computed: {
        getStatusesProps() {
            return {
                label: this.$t("liveView.filters.taskStatus"),
                options: this.statusesData,
                hasCheckbox: true,
                isMultiselect: true,
                clearableChip: true
            };
        },
        testComputed: {
            // dropdown v-model for default values
            get() {
                return [this.list2[3]];
            },
            set(v) {
                this.testModel = v;
            }
        },
        rounded() {
            return !!this.toggleArray.find(elem => elem === "rounded");
        },
        clearable() {
            return !!this.toggleArray.find(elem => elem === "clearable");
        },
        clearableChip() {
            return true;
        },
        keepOneOptionSelected() {
            return !!this.toggleArray.find(
                elem => elem === "keepOneOptionSelected"
            );
        },
        errorLabel() {
            return this.toggleArray.find(elem => elem === "errorLabel");
        },
        label() {
            return this.toggleArray.find(elem => elem === "label");
        },
        hasChipValue() {
            return !!this.toggleArray.find(elem => elem === "hasChipValue");
        },
        addSearch() {
            return !!this.toggleArray.find(elem => elem === "addSearch");
        },
        disable() {
            return !!this.toggleArray.find(elem => elem === "disable");
        },
        fitParentContainer() {
            return !!this.toggleArray.find(
                elem => elem === "fitParentContainer"
            );
        },
        resetSelectedData() {
            return !!this.toggleArray.find(
                elem => elem === "resetSelectedData"
            );
        },
        closeOnSelection() {
            return !!this.toggleArray.find(elem => elem === "closeOnSelection");
        },
        hasCheckbox() {
            return !!this.toggleArray.find(elem => elem === "hasCheckbox");
        },
        separator() {
            return !!this.toggleArray.find(elem => elem === "separator");
        },
        error() {
            return !!this.toggleArray.find(elem => elem === "error");
        },
        isMultiselect() {
            return !!this.toggleArray.find(elem => elem === "isMultiselect");
        },
        isReadonly() {
            return !!this.toggleArray.find(elem => elem === "isReadonly");
        },
        simpleMenu() {
            return !!this.toggleArray.find(elem => elem === "isSimple");
        },
        ddlFullProps() {
            return {
                defaultValue: this.defaultValue,
                readonly: this.isReadonly,
                rounded: this.rounded,
                clearable: this.clearable,
                clearableChip: this.clearableChip,
                errorLabel: this.errorLabel,
                label: this.label,
                hasChipValue: this.hasChipValue,
                options: this.simpleMenu ? this.simpleList : this.list2,
                addSearch: this.addSearch,
                disable: this.disable,
                fitParentContainer: this.fitParentContainer,
                resetSelectedData: this.resetSelectedData,
                hasCheckbox: this.hasCheckbox,
                separator: this.separator,
                error: this.error,
                isMultiselect: this.isMultiselect
            };
        },
        ddlSelect() {
            return {
                isMultiselect: true,
                options: this.list2,
                addSearch: true,
                hasCheckbox: true,
                closeOnSelection: false,
                hideClearDataIcon: false
            };
        },
        ddlSelect2() {
            return {
                hasAvatar: true,
                isMultiselect: true,
                options: this.list2,
                addSearch: true,
                hideCheckbox: true,
                hasIcon: true,
                closeOnSelection: true,
                hideClearDataIcon: true
            };
        }
    },
    methods: {
        input240(ev) {
            console.log("onInput240px  with emitValue", ev);
        },
        change240(ev) {
            console.log("onChange 240px  with emitValue", ev);
        },
        input360(ev) {
            console.log("onInput360px", ev);
        },
        change360(ev) {
            console.log("onChange 360px", ev);
        },
        input660(ev) {
            console.log("onInmput 660px", ev);
        },
        setActivity() {
            const activity = { pluginType: "TASK_PLUGIN" };
            const icon = setPluginIcon(activity);
            return { name: icon };
        }
    }
};
